// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__1hdG6"};